import AudienceInfo from "@/components/AudienceInfo";
import employersStory from "@/assets/employers-story.png";

export default function ForEmployers() {
  return (
    <AudienceInfo
      testid="for-employers-page"
      tag="Employers"
      image={employersStory}
      imageAlt="From too many applications and unclear fit to clear job posts and qualified, eligible candidates"
      title="Find candidates who actually qualify."
      promise="Fewer irrelevant applications. Eligvia makes you state the real conditions of the role up front — location, work authorization, remote scope, contract — so you reach candidates who genuinely meet them."
      bullets={[
        "Structured job posting: mark each requirement as mandatory, preferred or flexible.",
        "Automatic contradiction checks (e.g. 'remote' but 'must reside in California').",
        "Candidates ranked by real eligibility first, then explainable fit — not keyword noise.",
        "Invite matched candidates to apply instead of waiting for inbound volume.",
      ]}
      note="The employer workspace (structured posting wizard, matched candidates, invite-to-apply) arrives in Phase 2B."
    />
  );
}
